import { useEffect, useMemo, useRef, useState } from "react";
import moment from "jalali-moment";

import { Box, Button, Card, Checkbox, Chip, Collapse, Fade, Grid, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import { DESTINATION, LAYOUT_MARGIN, SOURCE } from "Configs/home";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import IRAN from "Assets/Images/iran.jpg";
import PLAQUE_FLAG from "Assets/Images/plaqueFlag.jpg";
import CallIcon from "@mui/icons-material/Call";
import CONTACT from "Assets/Images/photo_mmd.jpg";
import { changeCallMode } from "Redux/contactSlice";
import { passengerData } from "./passengerData";

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 8,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContent: 56,
  bottomContentMargin: 16,
};

export default function Passenger() {
  const { showSupportLeftSide, selectedPassenger } = useAppSelector((state) => state.supportSide);

  const { height } = useWindowSize();
  const dispatch = useAppDispatch();

  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isOpen2, setIsOpen2] = useState<boolean>(false);
  const [isOpen3, setIsOpen3] = useState<boolean>(false);

  const toggleCollapse = () => setIsOpen((prev) => !prev);
  const toggleCollapse2 = () => setIsOpen2((prev) => !prev);
  const toggleCollapse3 = () => setIsOpen3((prev) => !prev);

  const sideRef = useRef<HTMLDivElement>(null);

  const passenger = passengerData[selectedPassenger - 1];

  return (
    <>
      <Fade in={showSupportLeftSide} mountOnEnter unmountOnExit>
        <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography fontWeight="800">جزییات مسافر</Typography>

            <Button
              startIcon={
                <KeyboardDoubleArrowDownIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "all 0.3s" }} />
              }
              sx={{ minWidth: "100px" }}
              onClick={toggleCollapse}
            >
              {isOpen ? "بستن" : "بازکردن"}
            </Button>
          </Stack>

          <Collapse in={isOpen}>
            <Box sx={{ overflow: "scroll", height: "440px" }}>
              <Stack
                sx={{
                  mt: 1,
                  p: 2,
                  width: "97%",
                  border: "1px solid #aaa",
                  borderRadius: 1,
                }}
              >
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "5px" }}>
                  <Grid item md={8} textAlign="left" className="fa-number">
                    <Typography color="common.black">{passenger.name}</Typography>
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Box sx={{ justifyContent: "center" }}>
                      <img src={passenger.src} alt="contact" style={{ width: "70px", height: "70px", borderRadius: "50%" }} />
                    </Box>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={8} textAlign="left" className="fa-number">
                    <Typography color="common.black">{passenger.phoneNumber}</Typography>
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Button
                      type="button"
                      variant="contained"
                      sx={{ minWidth: "45px", marginRight: "7px" }}
                      onClick={() => dispatch(changeCallMode(true))}
                    >
                      <CallIcon />
                    </Button>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={8} textAlign="left" className="fa-number">
                    <Typography color="common.black">تاریخ عضویت</Typography>
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">{passenger.joinDate}</Typography>
                  </Grid>
                </Grid>
              </Stack>
              <Stack
                sx={{
                  mt: 1,
                  p: 2,
                  width: "97%",
                  border: "1px solid #aaa",
                  borderRadius: 1,
                }}
              >
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "5px" }}>
                  <Grid item md={8} textAlign="left" className="fa-number">
                    <Typography color="common.black">اطلاعات بلیط</Typography>
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Chip label={passenger.active ? "فعال" : "غیر فعال"} style={{ color: passenger.active ? "green" : "red" }} />
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={3} textAlign="left" className="fa-number">
                    <Typography color="common.black">{passenger.ticketCode}</Typography>
                  </Grid>
                  <Grid container item md={9} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">خرید : {passenger.buyDate}</Typography>
                  </Grid>
                </Grid>

                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">درگاه : </Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black"> {passenger.port}</Typography>
                  </Grid>
                </Grid>

                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">وضعیت پرداخت : </Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Chip
                      label={passenger.payStatus ? "موفق" : "ناموفق"}
                      style={{ color: passenger.payStatus ? "green" : "red" }}
                    />
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Collapse>
        </Card>
      </Fade>

      <Fade in={showSupportLeftSide} mountOnEnter unmountOnExit>
        <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography fontWeight="800"> سوابق </Typography>

            <Button
              startIcon={
                <KeyboardDoubleArrowDownIcon sx={{ transform: isOpen2 ? "rotate(180deg)" : "", transition: "all 0.3s" }} />
              }
              sx={{ minWidth: "100px" }}
              onClick={toggleCollapse2}
            >
              {isOpen2 ? "بستن" : "بازکردن"}
            </Button>
          </Stack>

          <Collapse in={isOpen2}>
            <Box sx={{ overflow: "scroll", height: "440px" }}>
              <Stack
                sx={{
                  mt: 1,
                  p: 2,
                  width: "97%",
                  border: "1px solid #aaa",
                  borderRadius: 1,
                }}
              >
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "5px" }}>
                  <Grid item md={8} textAlign="left" className="fa-number">
                    <Typography color="common.black">سوابق</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={4} textAlign="left" className="fa-number">
                    <Typography color="common.black">{passenger.pathOffer?.source}</Typography>
                  </Grid>
                  <Grid container item md={4} className="fa-number">
                    <ArrowBackIosIcon sx={{ margin: "auto" }} />
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">{passenger.pathOffer?.destination}</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">{passenger.pathOffer?.go_Time} مبدا</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">{passenger.pathOffer?.arrive_Time} مقصد</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid
                    item
                    md={1.6}
                    textAlign="left"
                    className="fa-number"
                    sx={{
                      color: "#fff",
                      border: "1px solid #555",
                      padding: "4px",
                      minWidth: "25px",
                      textAlign: "center",
                      backgroundColor: "#39BCA3",
                    }}
                  >
                    ش
                  </Grid>
                  <Grid
                    item
                    md={1.6}
                    textAlign="left"
                    className="fa-number"
                    sx={{
                      color: "#000",
                      border: "1px solid #555",
                      padding: "4px",
                      minWidth: "25px",
                      textAlign: "center",
                      backgroundColor: "#fff",
                    }}
                  >
                    ی
                  </Grid>
                  <Grid
                    item
                    md={1.6}
                    textAlign="left"
                    className="fa-number"
                    sx={{
                      color: "#fff",
                      border: "1px solid #555",
                      padding: "4px",
                      minWidth: "25px",
                      textAlign: "center",
                      backgroundColor: "#39BCA3",
                    }}
                  >
                    د
                  </Grid>
                  <Grid
                    item
                    md={1.6}
                    textAlign="left"
                    className="fa-number"
                    sx={{
                      color: "#000",
                      border: "1px solid #555",
                      padding: "4px",
                      minWidth: "25px",
                      textAlign: "center",
                      backgroundColor: "#fff",
                    }}
                  >
                    س
                  </Grid>
                  <Grid
                    item
                    md={1.6}
                    textAlign="left"
                    className="fa-number"
                    sx={{
                      color: "#000",
                      border: "1px solid #555",
                      padding: "4px",
                      minWidth: "25px",
                      textAlign: "center",
                      backgroundColor: "#fff",
                    }}
                  >
                    چ
                  </Grid>
                  <Grid
                    item
                    md={1.6}
                    textAlign="left"
                    className="fa-number"
                    sx={{
                      color: "#000",
                      border: "1px solid #555",
                      padding: "4px",
                      minWidth: "25px",
                      textAlign: "center",
                      backgroundColor: "#fff",
                    }}
                  >
                    پ
                  </Grid>
                  <Grid
                    item
                    md={1.6}
                    textAlign="left"
                    className="fa-number"
                    sx={{
                      color: "#fff",
                      border: "1px solid #555",
                      padding: "4px",
                      minWidth: "25px",
                      textAlign: "center",
                      backgroundColor: "#39BCA3",
                    }}
                  >
                    ج
                  </Grid>
                </Grid>

                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={8} textAlign="left" className="fa-number">
                    <Typography color="common.black">تاریخ ثبت</Typography>
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">{passenger.pathOffer?.registerDate}</Typography>
                  </Grid>
                </Grid>
              </Stack>

              <Stack
                sx={{
                  mt: 1,
                  p: 2,
                  width: "97%",
                  border: "1px solid #aaa",
                  borderRadius: 1,
                }}
              >
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "5px" }}>
                  <Grid item md={8} textAlign="left" className="fa-number">
                    <Typography color="common.black">آخرین بلیط خریداری شده :</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={3} textAlign="left" className="fa-number">
                    <Typography color="common.black">{passenger.pathOffer?.lastTicket?.code}</Typography>
                  </Grid>
                  <Grid container item md={9} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">خرید : 12:20 1403/04/02</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={4} textAlign="left" className="fa-number">
                    <Typography color="common.black">{passenger.pathOffer?.lastTicket?.source}</Typography>
                  </Grid>
                  <Grid container item md={4} className="fa-number">
                    <ArrowBackIosIcon sx={{ margin: "auto" }} />
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">{passenger.pathOffer?.lastTicket?.destination}</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">{passenger.pathOffer?.lastTicket?.go_Time} مبدا</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">{passenger.pathOffer?.lastTicket?.arrive_Time} مقصد</Typography>
                  </Grid>
                </Grid>
              </Stack>
              <Stack
                sx={{
                  mt: 1,
                  p: 2,
                  width: "97%",
                  border: "1px solid #aaa",
                  borderRadius: 1,
                }}
              >
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "5px" }}>
                  <Grid item md={8} textAlign="left" className="fa-number">
                    <Typography color="common.black">اولین بلیط خریداری شده :</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={3} textAlign="left" className="fa-number">
                    <Typography color="common.black">ADCBD</Typography>
                  </Grid>
                  <Grid container item md={9} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">خرید : 12:20 1403/04/12</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={4} textAlign="left" className="fa-number">
                    <Typography color="common.black">رسالت</Typography>
                  </Grid>
                  <Grid container item md={4} className="fa-number">
                    <ArrowBackIosIcon sx={{ margin: "auto" }} />
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">تهرانسر</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">7:00 مبدا</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">8:00 مقصد</Typography>
                  </Grid>
                </Grid>
              </Stack>

              <Stack
                sx={{
                  mt: 1,
                  p: 2,
                  width: "97%",
                  border: "1px solid #aaa",
                  borderRadius: 1,
                }}
              >
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={9} textAlign="left" className="fa-number">
                    <Typography color="common.black">تعداد بلیط خریداری شده</Typography>
                  </Grid>
                  <Grid container item md={3} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">1000</Typography>
                  </Grid>
                </Grid>

                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">مدت عضویت</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">3ماه</Typography>
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Collapse>
        </Card>
      </Fade>

      <Fade in={showSupportLeftSide} mountOnEnter unmountOnExit>
        <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography fontWeight="800">بلیط های هفته جاری </Typography>

            <Button
              startIcon={
                <KeyboardDoubleArrowDownIcon sx={{ transform: isOpen3 ? "rotate(180deg)" : "", transition: "all 0.3s" }} />
              }
              sx={{ minWidth: "100px" }}
              onClick={toggleCollapse3}
            >
              {isOpen3 ? "بستن" : "بازکردن"}
            </Button>
          </Stack>

          <Collapse in={isOpen3}>
            <Box sx={{ overflow: "scroll", height: "450px" }}>
              <Stack
                sx={{
                  mt: 1,
                  p: 1,
                  width: "97%",
                  border: "1px solid #aaa",
                  borderRadius: 1,
                }}
              >
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "5px" }}>
                  <Grid item md={8} textAlign="left" className="fa-number">
                    <Typography color="common.black">بلیط های هفته جاری :</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={4} textAlign="left" className="fa-number">
                    <Typography color="common.black">شنبه: PNETH</Typography>
                  </Grid>
                  <Grid container item md={2} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Chip label="فعال" style={{ color: "green" }} />
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">12:20 1403/04/13</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={4} textAlign="left" className="fa-number">
                    <Typography color="common.black">هروی</Typography>
                  </Grid>
                  <Grid container item md={4} className="fa-number">
                    <ArrowBackIosIcon sx={{ margin: "auto" }} />
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">ازگل</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">6:00 مبدا</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">6:35 مقصد</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">درگاه پاسارگارد</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Chip label="موفق" style={{ color: "green" }} />
                  </Grid>
                </Grid>
                <hr style={{ margin: "10px 0" }} />
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={4} textAlign="left" className="fa-number">
                    <Typography color="common.black">یکشنبه: AHWBN</Typography>
                  </Grid>
                  <Grid container item md={3} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Chip label="منقضی" style={{ color: "#bdc307" }} />
                  </Grid>
                  <Grid container item md={5} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">14:40 1403/02/22</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={4} textAlign="left" className="fa-number">
                    <Typography color="common.black">ونک</Typography>
                  </Grid>
                  <Grid container item md={4} className="fa-number">
                    <ArrowBackIosIcon sx={{ margin: "auto" }} />
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">آزادی</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">14:10 مبدا</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">14:50 مقصد</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">درگاه پاسارگارد</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Chip label="موفق" style={{ color: "green" }} />
                  </Grid>
                </Grid>
                <hr style={{ margin: "10px 0" }} />
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={4} textAlign="left" className="fa-number">
                    <Typography color="common.black">دوشنبه: RTZBD</Typography>
                  </Grid>
                  <Grid container item md={3.5} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Chip label="مصرف شده" style={{ color: "rgb(215 150 24)" }} />
                  </Grid>
                  <Grid container item md={4.5} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">18:25 1403/07/10</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={4} textAlign="left" className="fa-number">
                    <Typography color="common.black">تجریش</Typography>
                  </Grid>
                  <Grid container item md={4} className="fa-number">
                    <ArrowBackIosIcon sx={{ margin: "auto" }} />
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">پونک</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">17:00 مبدا</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">18:20 مقصد</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">درگاه پاسارگارد</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Chip label="موفق" style={{ color: "green" }} />
                  </Grid>
                </Grid>
                <hr style={{ margin: "10px 0" }} />
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={5} textAlign="left" className="fa-number">
                    <Typography color="common.black">چهارشنبه: AESBO</Typography>
                  </Grid>
                  <Grid container item md={2.5} className="fa-number">
                    <Chip label="کنسل" style={{ color: "rgb(237 28 28)" }} />
                  </Grid>
                  <Grid container item md={4.5} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">10:00 1403/03/12</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={4} textAlign="left" className="fa-number">
                    <Typography color="common.black">تهرانپارس</Typography>
                  </Grid>
                  <Grid container item md={4} className="fa-number">
                    <ArrowBackIosIcon sx={{ margin: "auto" }} />
                  </Grid>
                  <Grid container item md={4} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">مولوی</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">7:05 مبدا</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Typography color="common.black">8:15 مقصد</Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "15px" }}>
                  <Grid item md={6} textAlign="left" className="fa-number">
                    <Typography color="common.black">درگاه پاسارگارد</Typography>
                  </Grid>
                  <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                    <Chip label="موفق" style={{ color: "green" }} />
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Collapse>
        </Card>
      </Fade>
    </>
  );
}
